import React from "react";
import Section from "../section";
import FeaturedProject from "./projects/featuredProject";
import {
  getFirestore,
  collection,
  query,
  limit,
  getDocs,
  where,
} from "firebase/firestore";
import editorCode from "../../asserts/images/newImg/4.jpg";
import { app } from "../../firebase/firebase";
import styled from "styled-components";

const featuredPproject = [
  {
    name: "Online editor Code",
    description: `I have built is an online code editor that allows users to write and execute JavaScript 
    and HTML code, and view the results directly 
    in the browser. The platform also allows users to 
    create new files and delete existing ones, 
    providing flexibility in managing 
    their projects. Additionally, 
    the platform can be used as a tool for 
    learning, as it allows users to experiment with 
     different code snippets and see the 
     results in real-time.`,
    tech: ["React", "Javascript"],
    external: "https://hocineismail.github.io/react-editor-js-html",
    github: "https://github.com/hocineismail/react-editor-js-html",
    img: editorCode,
  },
  {
    name: "Recorder and Music Player",
    description: `The Recorder and Music Player project is a dynamic application that combines the functionalities of a voice recorder and a music player. It provides a seamless experience for recording your own audio and enjoying your favorite music tracks. The project utilizes modern technologies, such as React and TypeScript, to deliver a reliable and user-friendly interface.`,
    tech: ["React", "Javascript"],
    external: "https://recorder-music-player.netlify.app/",
    github: "https://github.com/hocineismail/Music-player",
    img: `https://raw.githubusercontent.com/hocineismail/Music-player/main/public/gallary.png`,
  },
  {
    name: "Quiz Online",
    description: `The project is an online quiz for JavaScript that allows users to test their knowledge and skills on the language with a set of questions related to JavaScript, each with a designated time limit. After completing the quiz, users can view their results, including their score, and it provides a convenient and 
    interactive way to improve understanding of 
    JavaScript and track progress..`,
    tech: ["React", "Javascript"],
    external: "https://hocineismail.github.io/Javascript-Online-Quiz-/",
    github: "https://github.com/hocineismail/Javascript-Online-Quiz-",
    img: `https://api.ismailhocine.com/public/uploads/image-1606662949647.png`,
  },
  {
    name: "Wasla",
    description: `  The project is a mobile app that allows users to request delivery to their current location and track it in real-time. It uses GPS to determine location and provides a simple interface for placing requests and tracking deliveries.`,
    tech: [
      "React, React Native",
      "Node.js",
      "Express.js",
      "Javascript",
      "Mongodb",
    ],
    external:
      "https://play.google.com/store/apps/details?id=com.wasladelivery.wasladeliveryApp",
    img: `https://mostaql.hsoubcdn.com/uploads/thumbnails/470165/5f8bfd9ff25cd/image-1602955769416.png`,
  },
];

export default function Projects() {
  const [data, setData] = React.useState([]);
  const db = getFirestore(app);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const getLatestProjects = async () => {
    const projectsCollection = collection(db, "projects");
    const q = query(
      projectsCollection,
      where("highlighted", "==", true),
      // orderBy("createdAt", "desc"), // Sort by createdAt field in descending order
      limit(100) // Limit the results to the latest 100
    );

    const querySnapshot = await getDocs(q);
    const projects = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return projects;
  };

  React.useEffect(() => {
    getLatestProjects()
      .then((projects) => {
        setData(projects);
        setIsLoading(false);
        console.log(projects);
      })
      .catch((error) => {
        setError(error.message);
        setIsLoading(false);
      });
  }, []);

  console.log(featuredPproject);
  return (
    <Section name="Highlighted Projects" id="projects">
      {isLoading && <>loading</>}
      {error && <>error</>}
      <ProjectGrid>
        {data.map((item, index) => (
          <FeaturedProject
            key={"featured-project-" + index}
            name={item.name}
            description={item.minDescription}
            tech={item.tech}
            openPage={item.images?.length > 0 ? true : false}
            index={index}
            img={item.img}
            external={item.external}
            github={item.github}
            id={item.id}
          />
        ))}{" "}
      </ProjectGrid>
      {/* <h2 style={{ color: "white", textAlign: "center", margin: "100px" }}>
        Other project
      </h2>
      <RowProjects>
        {projectsList.map((item, index) => (
          <Project
            key={"featured-project-" + index}
            name={item.name}
            description={item.description}
            tech={item.tech}
            index={index}
            external={item.external}
            github={item.github}
          />
        ))}
      </RowProjects> */}
    </Section>
  );
}

const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media only screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
